// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__30IF6","header":"Messages_header__lhifY"};